// Static fallback so the landing page can render instantly without waiting
// for /api/movie. The API response refreshes these values in the background.
// IMPORTANT: default to "unknown region" so the page hides the price until
// /api/geo confirms — matches the product rule of "if country unknown, show
// only '60 Days Access', no price".
export const DEFAULT_PRICING_UNKNOWN = {
  region: null,
  country_name: null,
  currency: null,
  currency_symbol: null,
  price: null,
  access_days: 60,
  tip_tiers: [],
  tip_min: 1,
  auto_detected: false,
};

export const DEFAULT_PRICING_INTL = {
  region: "INTL",
  country_name: "International",
  currency: "USD",
  currency_symbol: "$",
  price: 2.99,
  access_days: 60,
  tip_tiers: [100, 500, 1000],
  tip_min: 1,
  auto_detected: true,
};

export const DEFAULT_PRICING_IN = {
  region: "IN",
  country_name: "India",
  currency: "INR",
  currency_symbol: "₹",
  price: 79,
  access_days: 60,
  tip_tiers: [49, 199, 499, 999],
  tip_min: 49,
  auto_detected: true,
};

export const DEFAULT_PRICING_SAARC = {
  region: "SAARC",
  country_name: "South Asia",
  currency: "USD",
  currency_symbol: "$",
  price: 0.5,
  access_days: 60,
  tip_tiers: [5, 25, 100],
  tip_min: 1,
  auto_detected: true,
};

export const DEFAULT_MOVIE_DATA = {
  movie: {
    id: "byo-cha-khape",
    title: "Byo Cha Khape",
    tagline: "Biggest Blockbuster Sindhi comedy-drama.",
    presented_by: "Sindhionism Presents",
    synopsis:
      "Byo Cha Khape is a Sindhi comedy-drama where a harmless lie by two friends spirals into unexpected twists of romance, debt, and peril. At its heart, it's a story of friendship and the enduring belief that truth always triumphs.",
    runtime: "2h 19m",
    language: "Sindhi (English subtitles)",
    year: "2025",
    release_date: "12 September 2025",
    director: "Divesh Nainani",
    producer: "Dirven Hazari · Spectrum Studios",
    cast: ["Nikhil Jagiasi", "Mohit Sharma", "Muskan Lalwani", "Prem Chhabria", "Krishu Sharma"],
    vimeo_id: "1204109134",
    vimeo_aspect_padding: "41.89%",
    poster_url:
      "https://wsrv.nl/?url=customer-assets.emergentagent.com/job_byo-cha-khape/artifacts/m330kfrp_Untitled%20design%20-%202026-06-20T173229.396.png&w=1920&q=72&output=webp",
    poster_url_mobile:
      "https://wsrv.nl/?url=customer-assets.emergentagent.com/job_byo-cha-khape/artifacts/r6sqvjm6_byo%20cha%20khape%20%2835%29.png&w=900&q=72&output=webp",
    still_url:
      "https://wsrv.nl/?url=customer-assets.emergentagent.com/job_byo-cha-khape/artifacts/lsx5hphi_byo%20cha%20khape%20%2834%29.png&w=1400&q=72&output=webp",
  },
  // Initial render uses the "unknown" pricing shape so we never show the wrong
  // price for a brief moment — /api/geo replaces it with the right tier.
  pricing: DEFAULT_PRICING_UNKNOWN,
  min_price: null,
  lifetime_threshold: null,
  suggested_tiers: [],
};
